import firebase from 'firebase/app';
import 'firebase/messaging';

let cachedTokenPromise = null;

export const initializeFirebase = () => {
  if (isIosWebView()) {
    console.log("iOS WebView wykryty – pomijam inicjalizację FCM");
    return;
  }

  const firebaseConfig = {
    apiKey: "AIzaSyDf1_EI7kLd7RgjPJL8bKPHQvx3K_yps0A",
    authDomain: "trackericemonkeybe.firebaseapp.com",
    projectId: "trackericemonkeybe",
    storageBucket: "trackericemonkeybe.firebasestorage.app",
    messagingSenderId: "223938382527",
    appId: "1:223938382527:web:ae659502d409fea904940a",
    measurementId: "G-2FJ3WRVT5J"
  };

  firebase.initializeApp(firebaseConfig);

  // Pre-warm: if permission already granted, get token in background
  if (Notification.permission === 'granted' && 'serviceWorker' in navigator && !window.__nativePushToken) {
    cachedTokenPromise = navigator.serviceWorker.ready.then(swReg =>
      firebase.messaging().getToken({
        vapidKey: "BENzlCD50taGwmSE8KR3EcgQCpX00LFGE9i9VdmzdFThXRgMPHiT27_AEeS10xe-4LxIJAB0BeVXV_WOxAMVTFs",
        serviceWorkerRegistration: swReg
      })
    ).catch(() => null);
  }
}

function isIosWebView() {
  const ua = navigator.userAgent;
  return (
    /iPhone|iPad|iPod/i.test(ua)
  );
}

export const askForPermissionToReceiveNotifications = async () => {
    // If running inside the native iOS app, use the native push token
    // injected by AppDelegate instead of requesting a web push token.
    if (window.__nativePushToken) {
        console.info("[Firebase] Using native iOS push token");
        localStorage.setItem("fcm_token", window.__nativePushToken);
        return { status: "SUCCESS", token: window.__nativePushToken };
    }
    if (window.webkit?.messageHandlers?.nativePush) {
        console.info("[Firebase] Native iOS app detected, waiting for token...");
        const token = await new Promise((resolve) => {
            let attempts = 0;
            const check = setInterval(() => {
                if (window.__nativePushToken) {
                    clearInterval(check);
                    resolve(window.__nativePushToken);
                } else if (++attempts >= 50) {
                    clearInterval(check);
                    resolve(localStorage.getItem("fcm_token") || null);
                }
            }, 100);
        });
        if (token) {
            console.info("[Firebase] Got native iOS push token after waiting");
            localStorage.setItem("fcm_token", token);
            return { status: "SUCCESS", token: token };
        }
        console.warn("[Firebase] Native iOS app but no token available");
    }

  try {
    if (isIosWebView()) {
      const tokenIOS =  window.localStorage.getItem('token') ?? '';
      if (tokenIOS !== '') {
        return {
          status: "SUCCESS",
          token: tokenIOS
        };
      } else {
        return ({
          status: "FAIL",
          error: 'Notification permission denied'
        });
      }
    } else {
      const messaging = firebase.messaging();
      let permission = await Notification.requestPermission();
      if (permission === "granted") {
        let token;
        if (cachedTokenPromise) {
          token = await cachedTokenPromise;
        }
        if (!token) {
          const swReg = await navigator.serviceWorker.ready;
          token = await messaging.getToken({
            vapidKey: "BENzlCD50taGwmSE8KR3EcgQCpX00LFGE9i9VdmzdFThXRgMPHiT27_AEeS10xe-4LxIJAB0BeVXV_WOxAMVTFs",
            serviceWorkerRegistration: swReg
          });
        }
        return ({
          status: "SUCCESS",
          token: token
        });
      } else {
        return ({
          status: "FAIL",
          error: 'Notification permission denied'
        });
      }
    }
  } catch (error) {
    return ({
      status: "FAIL",
      error: error
    });
  }
}
